<div [ngSwitch]="selectedAudience">
  <div *ngSwitchCase="AudienceTypes.Manual">
    <aayn-manual-audience--facebook></aayn-manual-audience--facebook>
  </div>
</div>
